import script from "./addUser.vue?vue&type=script&setup=true&lang=js"
export * from "./addUser.vue?vue&type=script&setup=true&lang=js"

import "./addUser.vue?vue&type=style&index=0&id=6b0bc1f6&lang=css"

const __exports__ = script;

export default __exports__